__webpack_require__.p = "https://aqarmap.com.eg/ma-public/";